export function resolveMediaAssetUrl(asset) {
    if (!asset || typeof asset !== 'object') return null;
    return asset?.variants?.webpThumb?.url
        || asset?.variants?.webpFullHd?.url
        || asset?.variants?.webpOriginal?.url
        || asset?.original?.url
        || null;
}

export function resolveBuybackPhotoUrl(row) {
    const photos = row?.item?.photoIds;
    if (!Array.isArray(photos) || !photos.length) return null;
    const first = photos.find((item) => item && typeof item === 'object');
    return resolveMediaAssetUrl(first);
}

export function resolveSalePhotoUrl(row) {
    const photos = row?.photoIds;
    if (!Array.isArray(photos) || !photos.length) return null;
    const first = photos.find((item) => item && typeof item === 'object');
    return resolveMediaAssetUrl(first);
}

export function resolveDevicePhotoUrl(row) {
    const imagePath = row?.image;
    if (!imagePath) return null;
    if (/^https?:\/\//i.test(imagePath)) return imagePath;
    if (String(imagePath).startsWith('/')) return `${process.env.REACT_APP_IMAGE_URL}${imagePath}`;
    return `${process.env.REACT_APP_IMAGE_URL}/public/device-images/${imagePath}`;
}
